__turbopack_context__.v({
  "colorGrid": "OverrideSelector-module__uVJcra__colorGrid",
  "colorSwatch": "OverrideSelector-module__uVJcra__colorSwatch",
  "colorSwatchSelected": "OverrideSelector-module__uVJcra__colorSwatchSelected",
  "colorSwatch__preview": "OverrideSelector-module__uVJcra__colorSwatch__preview",
  "sliderGrid": "OverrideSelector-module__uVJcra__sliderGrid",
});
